import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import dayjs from 'dayjs';
import { categoryArtistOrTour } from '@/constants/artist';
export function formatArtistListData() {
  var _a$tourInfoVo, _a$tourInfoVo$tourGro, _a$tourInfoVo2;
  var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    categoryId = _ref.categoryId,
    index = _ref.index;
  var curObj = categoryArtistOrTour[a.tourType || 1];
  a.mainImg = a[curObj.headKey] || 'https://p0.meituan.net/scarlett/2b130486b1c209d988544b9a5cc454ff4719.png';
  a.jumpUrl = "/artist?ipId=".concat(a.ipId);
  a.rightTopTitle = a.updateType > 0 ? 'NEW' : '';
  a.mainTitle = a[curObj.nameKey] || '';
  a.leftBottomTitle = a.concern;
  a.dataSeed = {
    bid: 'b_movie_eundh7k9_mc',
    viewBid: 'b_movie_eundh7k9_mv',
    celebrity_id: a.celebrityId || '',
    tour_id: a.tourId || '',
    drama_id: a.dramaId || '',
    index: index,
    category_id: categoryId
  };
  a.tourInfoVo.tourGroupProjectVoList = (_a$tourInfoVo = a.tourInfoVo) === null || _a$tourInfoVo === void 0 ? void 0 : (_a$tourInfoVo$tourGro = _a$tourInfoVo.tourGroupProjectVoList) === null || _a$tourInfoVo$tourGro === void 0 ? void 0 : _a$tourInfoVo$tourGro.map(function (item) {
    return formatTourData(item, {
      categoryId: categoryId,
      index: index,
      a: a
    });
  });
  a.tourInfoVo.tourGroupProjectVoList = changeTourWidth((_a$tourInfoVo2 = a.tourInfoVo) === null || _a$tourInfoVo2 === void 0 ? void 0 : _a$tourInfoVo2.tourGroupProjectVoList);
  return a;
}
export function formatTourData(tourItem, _ref2) {
  var categoryId = _ref2.categoryId,
    index = _ref2.index,
    outItem = _ref2.a;
  var _ref3 = tourItem || {},
    stockOutRegister = _ref3.stockOutRegister,
    unusualSaleStatus = _ref3.unusualSaleStatus,
    saleStatus = _ref3.saleStatus;
  var btnStatus;
  var btnText;
  if (saleStatus === 1) {
    btnStatus = 'normal';
    btnText = '去预约';
  } else if (saleStatus === 2 || saleStatus === 3) {
    btnStatus = 'normal';
    btnText = '去抢票';
  } else if ((saleStatus === 4 || saleStatus === 5) && stockOutRegister === 1) {
    btnStatus = 'stockout';
    btnText = '缺货登记';
  } else if ((saleStatus === 4 || saleStatus === 5) && stockOutRegister === 0) {
    btnStatus = 'unusual';
    btnText = '售罄';
  } else if (unusualSaleStatus === 2) {
    btnStatus = 'unusual';
    btnText = '全部延期';
  } else if ([3, 5, 6].includes(unusualSaleStatus)) {
    btnStatus = 'unusual';
    btnText = '部分延期';
  } else if (unusualSaleStatus === 4) {
    btnStatus = 'unusual';
    btnText = '部分取消';
  } else if (unusualSaleStatus === 1) {
    btnStatus = 'unusual';
    btnText = '全部取消';
  }
  var tourTextObj = getTextObj({
    btnStatus: btnStatus,
    btnText: btnText,
    tourItem: tourItem
  });
  return Object.assign({}, tourItem, tourTextObj, {
    btnStatus: btnStatus,
    btnText: btnText,
    dataSeed: {
      bid: 'b_movie_34r244u4_mc',
      viewBid: 'b_movie_34r244u4_mv',
      index: index,
      performance_id: tourItem.performanceId,
      category_id: categoryId,
      celebrity_id: outItem.celebrityId || '',
      tour_id: outItem.tourId || '',
      drama_id: outItem.dramaId || '',
      needTag: true
    }
  });
}
export function getTextObj(_ref4) {
  var btnStatus = _ref4.btnStatus,
    btnText = _ref4.btnText,
    tourItem = _ref4.tourItem;
  var _ref5 = tourItem || {},
    onSaleTime = _ref5.onSaleTime;
  var isCountDown = false;
  if (btnText !== '去预约') {
    isCountDown = false;
    if (btnText === '去抢票') return {
      tourText: '火热抢购中',
      tourWidth: 'middle',
      isCountDown: isCountDown
    };
    if (btnStatus === 'normal' && !onSaleTime) return {
      tourText: '即将开抢',
      tourWidth: 'middle',
      isCountDown: isCountDown
    };
    return {
      tourText: btnText,
      tourWidth: 'min',
      isCountDown: isCountDown
    };
  } else {
    if (onSaleTime) {
      if (onSaleTime - Date.now() > 24 * 60 * 60 * 1000) {
        isCountDown = false;
        return {
          tourText: dayjs(onSaleTime).format('MM月DD日 HH:mm 开抢'),
          tourWidth: 'max',
          isCountDown: isCountDown
        };
      } else {
        isCountDown = true;
        return {
          tourText: '',
          tourWidth: 'middle',
          isCountDown: isCountDown
        };
      }
    } else {
      isCountDown = false;
      return {
        tourText: '即将开抢',
        tourWidth: 'middle',
        isCountDown: isCountDown
      };
    }
  }
}
export function changeTourWidth(tourList) {
  if (tourList.length === 2) {
    var _newTourList$, _newTourList$2, _newTourList$3, _newTourList$4, _newTourList$5, _newTourList$6;
    var newTourList = JSON.parse(JSON.stringify(tourList)) || [];
    if (((_newTourList$ = newTourList[0]) === null || _newTourList$ === void 0 ? void 0 : _newTourList$.tourWidth) === 'middle' && ((_newTourList$2 = newTourList[1]) === null || _newTourList$2 === void 0 ? void 0 : _newTourList$2.tourWidth) === 'min') {
      newTourList[0].tourWidth = 'middle-min-MIDDLE';
      newTourList[1].tourWidth = 'middle-min-MIN';
    }
    if (((_newTourList$3 = newTourList[0]) === null || _newTourList$3 === void 0 ? void 0 : _newTourList$3.tourWidth) === 'min' && ((_newTourList$4 = newTourList[1]) === null || _newTourList$4 === void 0 ? void 0 : _newTourList$4.tourWidth) === 'middle') {
      newTourList[0].tourWidth = 'middle-min-MIN';
      newTourList[1].tourWidth = 'middle-min-MIDDLE';
    }
    if (((_newTourList$5 = newTourList[0]) === null || _newTourList$5 === void 0 ? void 0 : _newTourList$5.tourWidth) === 'min' && ((_newTourList$6 = newTourList[1]) === null || _newTourList$6 === void 0 ? void 0 : _newTourList$6.tourWidth) === 'min') {
      newTourList[0].tourWidth = 'double-min';
      newTourList[1].tourWidth = 'double-min';
    }
    // if (newTourList[0]) newTourList[0].tourWidth = 'middle-min-MIDDLE'
    // if (newTourList[1]) newTourList[1].tourWidth = 'middle-min-MIN'
    return newTourList;
  }
  return tourList;
}
export function formatPositionItem() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var _ref6 = arguments.length > 1 ? arguments[1] : undefined,
    categoryId = _ref6.categoryId;
  return list.map(function (item, index) {
    (item.materialVOList || []).forEach(function (keyItem) {
      item[keyItem.key] = keyItem.value;
    });
    var positonType = item.positonType,
      mainContent = item.mainContent;
    var jumpUrl = '';
    if (positonType === '2') {
      // 活动
      jumpUrl = mainContent;
    } else if (positonType === '1') {
      // 项目id
      jumpUrl = "/myshow/#/detail/".concat(mainContent);
    }
    item.jumpUrl = jumpUrl;
    item.tagSeed = {
      index: index
    };
    item.dataSeed = {
      bid: 'b_movie_rdn5sm3u_mc',
      viewBid: 'b_movie_rdn5sm3u_mv',
      index: index,
      category_id: categoryId,
      main_content: mainContent,
      position_type: positonType,
      // 后端单词拼错了
      needTag: true
    };
    return item;
  });
}
export function setModuleData(_ref7) {
  var categoryListData = _ref7.categoryListData,
    categoryId = _ref7.categoryId,
    idMap = _ref7.idMap,
    data = _ref7.data,
    _ref7$key = _ref7.key,
    key = _ref7$key === void 0 ? 'data' : _ref7$key;
  var curCategoryListData = JSON.parse(JSON.stringify(categoryListData || {}));
  var curCategoryData = curCategoryListData && curCategoryListData[categoryId] || {};
  var curModuleData = curCategoryData[idMap];
  curCategoryData[idMap] = Object.assign({}, curModuleData, _defineProperty({}, key, data));
  curCategoryListData[categoryId] = curCategoryData;
  return curCategoryListData;
}
export function setCategoryData(_ref8) {
  var categoryListData = _ref8.categoryListData,
    categoryId = _ref8.categoryId,
    data = _ref8.data,
    key = _ref8.key;
  if (!key) return;
  var curCategoryListData = JSON.parse(JSON.stringify(categoryListData || {}));
  var curCategoryData = curCategoryListData && curCategoryListData[categoryId] || {};
  curCategoryData = Object.assign({}, curCategoryData, _defineProperty({}, key, data));
  curCategoryListData[categoryId] = curCategoryData;
  return curCategoryListData;
}